import { m } from "framer-motion";

export const mentalplus = {
 mentalplus_tab_help: 'Mi boya',
 mentalplus_tab_videos: 'Vídeos',
 mentalplus_tab_home: 'Mi mundo',
 mentalplus_tab_evolution: 'Evolución',
 mentalplus_tab_account: 'Cuenta',
 mentalplus_tab_questionnaires: 'Cuestionarios',
 mentalplus_account_page_title: 'Cuenta y ajustes',
 mentalplus_account_manage: 'Gestionar mi cuenta',
 mentalplus_account_deactivate: 'Desactivar mi cuenta',
 mentalplus_account_deactivate_message: '¿Desea desactivar su cuenta?',
 mentalplus_account_notifications: 'Gestionar notificaciones',
 mentalplus_account_notification_email: 'Notificaciones por correo',
 mentalplus_account_notification_sms: 'Notificaciones por SMS',
 mentalplus_account_notification_push: 'Notificaciones push',
 mentalplus_account_notification_add_contact: 'Agregue un contacto para activar esta notificación',
 mentalplus_account_notification_push_hint: 'Actívelo para recibir notificaciones en este dispositivo',
 mentalplus_account_notification_push_permission_required: 'Permiso denegado. Active las notificaciones en la configuración del navegador o del dispositivo.',
 mentalplus_unsubscribe_title: 'Preferencias de notificación',
 mentalplus_unsubscribe_intro: 'Gestione las notificaciones que recibe de este estudio.',
 mentalplus_unsubscribe_save: 'Guardar',
 mentalplus_unsubscribe_saved: 'Sus preferencias se han guardado.',
 mentalplus_unsubscribe_error: 'Se ha producido un error. Inténtelo de nuevo.',
 mentalplus_unsubscribe_invalid: 'Este enlace para darse de baja ya no es válido.',
 mentalplus_unsubscribe_push_note: 'Para activar las notificaciones push, abra la aplicación.',
 mentalplus_unsubscribe_loading: 'Cargando sus preferencias…',
 mentalplus_account_tutorials: 'Ver tutoriales',
 mentalplus_account_language: 'Cambiar idioma',
 mentalplus_account_about: 'Acerca de',
 mentalplus_account_contact: 'Contáctanos',
 mentalplus_account_app_version: 'Versión de la aplicación',
 mentalplus_filtre_ile: 'Isla',
 mentalplus_tab_ile_moi: 'Yo',
 mentalplus_tab_ile_amour: 'Amor',
 mentalplus_tab_ile_amis: 'Amigos',
 mentalplus_tab_ile_famille: 'Familia',
 mentalplus_tab_ile_ecrans: 'Pantalla',
 mentalplus_tab_ile_loisirs: 'Ocio',
 mentalplus_video_filtres: 'Filtros',
 mentalplus_video_enregistrees: 'Guardados',
 mentalplus_videos_enregistrees: 'Vídeos guardados',
 mentalplus_video_rechercher: 'Buscar',
 mentalplus_help_signes: 'Signos',
 mentalplus_help_solutions: 'Soluciones',
 mentalplus_help_num_soutiens: 'Números de apoyos',
 mentalplus_help_signes_question: '¿Cuáles son las señales que me hacen darme cuenta de que estoy empezando a sentirme mal?',
 mentalplus_help_solutions_question: '¿Qué soluciones pueden ayudarme a sentirme mejor?',
 mentalplus_help_num_epingle: 'Número fijado',
 mentalplus_help_num_utiles: 'Números útiles',
 mentalplus_help_num_epingle_choix: 'Elegir el número para fijar',
 mentalplus_help_num_valider: 'Confirmar este número',
 mentalplus_help_num_gerer: 'Gestionar mis números de emergencia',
 mentalplus_help_num_gerer_proches: 'Gestionar los números de mis contactos cercanos',
 mentalplus_help_num_enregistrer: 'Guardar',
 mentalplus_help_solutions_ajouter: 'Añadir una solución',
 mentalplus_help_ajouter: 'Añadir',
 mentalplus_help_signes_ajouter: 'Añadir un señal',
 mentalplus_help_num_proches_ajouter: 'Añadir un contacto cercano',
 mentalplus_help_num_proches_nom: 'Nombre del contacto (ej: Papá)',
 mentalplus_help_num_proches_numero: 'Número de teléfono',
 mentalplus_help_num_urgences: 'Números de emergencia',
 mentalplus_help_num_proches: 'Contactos cercanos',
 mentalplus_video_retour: 'Volver',
 mentalplus_video_description: 'Descripción',
 mentalplus_video_voir_plus: 'ver más',
 mentalplus_video_description_empty: 'No hay descripción para este vídeo.',
 mentalplus_video_tout_voir: 'Ver todo',
 mentalplus_video_renitialiser: 'Reiniciar',
 mentalplus_filtre_categories: 'Categorías',
 mentalplus_filtre_categories_explications: 'Explicaciones',
 mentalplus_filtre_categories_solutions: 'Soluciones',
 mentalplus_filtre_realisee: 'Realizada por',
 mentalplus_filtre_realisee_professionnels: 'Profesionales',
 mentalplus_filtre_realisee_communaute: 'Comunidad',
 mentalplus_filtre_realisee_2: 'Realizada para',
 mentalplus_filtre_realisee_collegiens: 'Estudiantes de secundaria',
 mentalplus_filtre_realisee_lyceens: 'Estudiantes de bachillerato',
 mentalplus_filtre_realisee_etudiants: 'Estudiantes universitarios',
 mentalplus_filtre_realisee_jeunes_actifs: 'Jóvenes activos',
 mentalplus_filtre_realisee_sans_activite: 'Sin actividad',
 mentalplus_filtre_trier: 'Ordenar por',
 mentalplus_filtre_trier_popularite: 'Popularidad',
 mentalplus_filtre_trier_recent: 'Reciente',
 mentalplus_filtre_trier_ancien: 'Antiguo',
 mentalplus_menu_share: 'Compartir {{appName}}',
 mentalplus_menu_profile: 'Perfil',
 mentalplus_menu_island_settings: 'Configuración de la isla',
 menu_share: 'Compartir',
 mentalplus_menu_conatct: 'Contáctanos',
 mentalplus_menu_objet: 'Asunto',
 mentalplus_menu_objet_champ: 'Selecciona un asunto', 
 mentalplus_menu_equipe: '¿Quiénes somos?',
 mentalplus_menu_signaler_un_bug: 'Reportar un error',
 mentalplus_menu_contacter_l_equipe: 'Contactar al equipo',
 mentalplus_menu_autre: 'Otro',
 mentalplus_menu_que_faire: '¿Qué hacer?',
 mentalplus_menu_son: 'Sonido',
 mentalplus_video_recherche: 'Ningún vídeo coincide con estos filtros.',
mentalplus_ile_moi_quizz: 'Cuestionario de ansiedad y depresión',
mentalplus_video_enregistree: 'No hay videos guardados por el momento.',
};
